<template>
  <div id="main">
    <h1>
      <transition
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated faster fadeOut"
      >
        <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
      </transition>Svi Događaji
    </h1>
    <table-events></table-events>
  </div>
</template>

<script>
import TableEvents from '@/components/table/TableEvents.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    TableEvents
  },
  created() {
    let allCommunities = this.$store.getters.getCommunitiesImploded;
    let communityIds = [];
    for (const comm of allCommunities) {
      communityIds.push(comm.id);
    }
    this.getEventsForMultipleCommunities(communityIds);
  },
  methods: {
    ...mapActions('table', ['getEventsForMultipleCommunities']),
    back() {
      this.$router.back();
    }
  }
};
</script>

<style>
#main {
  padding: 0px 10px;
  padding-top: 50px;
}
h1 {
  text-align: center;
  padding-bottom: 20px;
}
</style>
